import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Chapter, Reveal } from "@/components/Reveal";

const WORDS = ["Persone.", "Organizzazione.", "Numeri.", "Vendite.", "Marketing.", "Tempo."];

const Word = ({ progress, range, children }) => {
  const opacity = useTransform(progress, range, [0.1, 1]);
  const y = useTransform(progress, range, [16, 0]);
  return (
    <motion.span
      style={{ opacity, y }}
      className="mr-[0.32em] inline-block font-display text-4xl font-extrabold tracking-tighter text-ink sm:text-6xl lg:text-7xl"
    >
      {children}
    </motion.span>
  );
};

const Problem = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });

  return (
    <section id="problema" data-testid="problem-section" className="bg-fog py-28 text-ink lg:py-40">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <Chapter index="01" label="Il problema" />
        <Reveal>
          <h2 className="max-w-4xl font-display text-4xl font-extrabold leading-[1.05] tracking-tighter sm:text-5xl lg:text-6xl">
            Un'azienda non si blocca mai per caso.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-10 max-w-2xl">
          <p className="text-base leading-relaxed text-ink/60 md:text-lg">
            Quando un'azienda smette di crescere, raramente il problema è uno solo.
          </p>
        </Reveal>

        <div ref={ref} className="mt-20 max-w-5xl lg:mt-28" data-testid="problem-words">
          {WORDS.map((w, i) => (
            <Word key={w} progress={scrollYProgress} range={[i / WORDS.length, (i + 1) / WORDS.length]}>
              {w}
            </Word>
          ))}
        </div>

        <Reveal className="mt-20 lg:mt-28">
          <p className="font-display text-2xl font-bold tracking-tight sm:text-3xl">
            Tutto è collegato.
          </p>
          <div className="mt-8 border-l-2 border-accent-dark pl-6">
            <p className="text-base text-ink/60 md:text-lg">Per questo non parto dalla soluzione.</p>
            <p className="mt-1 font-display text-xl font-bold tracking-tight md:text-2xl">
              Parto dall'<span className="text-accent-dark">analisi</span>.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Problem;
